module.exports = __webpack_public_path__ + "static/media/yellow01.e9a6580e.svg";